import axios from 'axios';

const getAllExtractedDocuments = () =>
  axios.get(`/extracted_documents/get_firm_extracted_documents_for_export`);
const deleteExtractedDocument = id =>
  axios.get(`/extracted_documents/${id}/delete_extracted_document`);
const exportToCsv = ({ extractedDocumentId, companyId }) =>
  axios.post(`/extracted_documents/${extractedDocumentId}/export_to_csv`, {
    company_id: companyId,
  });
const addExtractedDocumentField = extractedDocumentField =>
  axios.post(
    '/extracted_documents/add_extracted_document_field',
    extractedDocumentField,
  );
const removeExtractedDocumentField = ({ extractedDocumentId, id }) =>
  axios.post('/extracted_documents/remove_extracted_document_field', {
    extracted_document_id: extractedDocumentId,
    id,
  });
const forceFormFields = ({ extractedDocumentId, formName }) =>
  axios.post('/extracted_documents/force_form_fields', {
    extracted_document_id: extractedDocumentId,
    form_name: formName,
  });
const getExportableForms = () =>
  axios.get('/extracted_documents/get_exportable_forms');
const updateMarkedAsOthers = ({
  companyId,
  extractedDocumentId,
  markedAsOthers,
}) =>
  axios.post(
    `/extracted_documents/${extractedDocumentId}/update_marked_as_others`,
    {
      company_id: companyId,
      marked_as_others: markedAsOthers,
    },
  );
const updateExtractedDocument = ({
  companyId,
  extractedDocumentId,
  extractedDocumentFields,
  status,
  name,
  documentType,
  reviewStatus,
}) =>
  axios.post(
    `/extracted_documents/${extractedDocumentId}/update_extracted_document`,
    {
      company_id: companyId,
      extracted_document_fields: extractedDocumentFields,
      document_type: documentType,
      review_status: reviewStatus,
      status,
      name,
    },
  );
const updateExtractedDocumentField = ({
  companyId,
  extractedDocumentId,
  extractedDocumentFieldId,
  correctedValue,
}) =>
  axios.post(
    `/extracted_documents/${extractedDocumentId}/update_extracted_document_field`,
    {
      company_id: companyId,
      extracted_document_field_id: extractedDocumentFieldId,
      corrected_value: correctedValue,
    },
  );
const updateTags = ({ companyId, extractedDocumentId, tags }) =>
  axios.post(`/extracted_documents/${extractedDocumentId}/update_tags`, {
    company_id: companyId,
    tags,
  });
const updateDescription = ({ companyId, extractedDocumentId, description }) =>
  axios.post(`/extracted_documents/${extractedDocumentId}/update_description`, {
    company_id: companyId,
    description,
  });
const getImportTaxReturnTasks = ({ companyId, year }) =>
  axios.get(`/extracted_documents/get_import_tax_return_tasks`, {
    params: {
      company_id: companyId,
      year: year,
    },
  });
const updateImportTaxReturnTask = ({ companyId, taskId, status }) =>
  axios.post(`/extracted_documents/update_import_tax_return_task`, {
    company_id: companyId,
    task_id: taskId,
    status: status,
  });
const deleteImportTaxReturnTask = ({ companyId, taskId }) =>
  axios.post(`/extracted_documents/delete_import_tax_return_task`, {
    company_id: companyId,
    task_id: taskId,
  });
const getFormMappingByName = ({ name }) =>
  axios.get(`/extracted_documents/get_form_mapping_by_name`, {
    params: {
      name,
    },
  });
const getPreviewAndExtractedDocumentFields = ({
  extractedDocumentId,
  companyId,
}) =>
  axios.post(
    `/extracted_documents/${extractedDocumentId}/get_preview_and_extracted_document_fields`,
    {
      company_id: companyId,
    },
  );
const addTaxReturnForm = ({ companyId, questionnaireId, name }) =>
  axios.post(`/extracted_documents/add_tax_return_form`, {
    company_id: companyId,
    questionnaire_id: questionnaireId,
    name,
  });
const getAnnotations = ({ companyId, extractedDocumentId }) =>
  axios.post(`/extracted_documents/${extractedDocumentId}/get_annotations`, {
    company_id: companyId,
  });
const saveAnnotations = ({ companyId, extractedDocumentId, annotations }) =>
  axios.post(`/extracted_documents/${extractedDocumentId}/save_annotations`, {
    company_id: companyId,
    annotations,
  });
const splitDocuments = ({ companyId, extractedDocumentId, documents }) =>
  axios.post(`/extracted_documents/split_documents`, {
    company_id: companyId,
    extracted_document_id: extractedDocumentId,
    documents: documents,
  });
const getExtractedDocument = ({ companyId, id }) =>
  axios.get(
    `/extracted_documents/${id}/get_extracted_document?company_id=${companyId}`,
  );
const downloadLeadsheet = ({ companyId, year }) =>
  axios.post(
    `/extracted_documents/download_leadsheet?company_id=${companyId}&year=${year}`,
    {
      responseType: 'arraybuffer',
    },
  );

export default {
  getAllExtractedDocuments,
  updateExtractedDocument,
  deleteExtractedDocument,
  addExtractedDocumentField,
  removeExtractedDocumentField,
  forceFormFields,
  getExportableForms,
  exportToCsv,
  getImportTaxReturnTasks,
  updateImportTaxReturnTask,
  deleteImportTaxReturnTask,
  getFormMappingByName,
  addTaxReturnForm,
  getAnnotations,
  saveAnnotations,
  updateTags,
  updateDescription,
  splitDocuments,
  getPreviewAndExtractedDocumentFields,
  getExtractedDocument,
  updateExtractedDocumentField,
  updateMarkedAsOthers,
  downloadLeadsheet,
};
